import { useContext } from 'react';
import { SizingContext } from './SizingContext';

export const useSizing = () => {
  const context = useContext(SizingContext);
  if (context === undefined) {
    throw new Error('useSizing must be used within a SizingProvider');
  }
  return context;
};
